import { render, staticRenderFns } from "./categoryDetails.vue?vue&type=template&id=78c89cc5&scoped=true"
import script from "./categoryDetails.vue?vue&type=script&lang=js"
export * from "./categoryDetails.vue?vue&type=script&lang=js"
import style0 from "./categoryDetails.vue?vue&type=style&index=0&id=78c89cc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c89cc5",
  null
  
)

export default component.exports